import React from "react"

const card = ({name, email}) => {
    return (
        <div className="pv0 tc bg-light-green dib br3 pa3 ma2 grow bw2 shadow-5">
            <img src={`https://robohash.org/${name}?size=180x200`} alt="robo"/>
            <>
                <h2>{name}</h2>
                <p>{email}</p>
            </>
        </div>
    )
}

export default card;